import React, { useState, useEffect } from 'react';
import { useAtaCodes } from "../../../providers/AtaCodeProvider";
import { useToast } from "../../../providers/ToastProvider";
import { NOTIFICATION_TYPES } from "../../ToastNotification/toastConstants";
import MaterialUITextInput from '../../TextFieldInput/MaterialUITextInput';

interface ATACodeFilterProps {
  ataCode: string;
  onATACodeChange: (code: string) => void;
  OnATACodeError: (error: boolean) => void;
  error: boolean; 
}

const ATACodeFilter: React.FC<ATACodeFilterProps> = ({ onATACodeChange, ataCode, OnATACodeError, error }) => {
  const [ATAError, setATAError] = useState(false);
  const { ataCodes, isAtaCodeHttpError } = useAtaCodes();
  const { addToast } = useToast();

  useEffect(() => {
    if (isAtaCodeHttpError) {
      addToast(NOTIFICATION_TYPES.WARNING, 'Unable to retrieve ATA codes.', 'Please try again.');
    }
  }, [isAtaCodeHttpError]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    // Allow only numbers
    const numericValue = value.replace(/[^0-9]/g, '');
    onATACodeChange(numericValue);
    validateATACode(numericValue);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const { key } = event;
    if (!/[0-9]|Backspace|Tab|ArrowLeft|ArrowRight/.test(key)) {
      event.preventDefault();
    }
  };

  const validateATACode = (code: string) => {
    const result = Array.isArray(ataCodes) ? ataCodes.map((e) => e.ChapterCode).includes(code) : null;
    let isValid = false;

    if (code.length === 0) {
      setATAError(false);
      isValid = true;
    } else if (!result || (code.length < 2 && code.length > 0)) {
      setATAError(true);
      isValid = false;
    } else {
      setATAError(false);
      isValid = true;
    }

    OnATACodeError(!isValid);
  };

  return (
    <div className="form-input">
      <MaterialUITextInput
        label="ATA"
        value={ataCode}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={() => validateATACode(ataCode)}
        error={error}
        helperText={ error ? "invalid entry" : ""}
        className="ata-filter-input"
        inputProps={{
          autoComplete: "off",
          maxLength: 2,
          pattern: "[0-9]{2}",
          inputMode: "numeric",
          'data-testid': "ata-code"
        }}
      />
    </div>
  );
};

export default ATACodeFilter;
